module.exports = __webpack_public_path__ + "static/assets/6bfe0ad95ec4d2070b817514d8cd4ecd.jpg";